var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"rounded-full ring-black object-cover shadow-md",style:(_vm.computedStyles),attrs:{"src":_vm.pathToImage,"alt":"Vue logos"}})
}
var staticRenderFns = []

export { render, staticRenderFns }